import React from 'react'
import classNames from 'classnames'
import { ReactComponent as MatchedIcon } from '../../../../assets/images/ccq/group-matched.svg'
import { ReactComponent as CloserLookIcon } from '../../../../assets/images/ccq/group-closer-look.svg'
import { ReactComponent as NotInRecordsIcon } from '../../../../assets/images/ccq/group-not-in-records.svg'
import { CcqCards, type CcqCard } from './ccqResultView'
import styles from './CcqStatusIcon.module.scss'

interface CcqStatusIconProps {
  card: CcqCard
  size: 'regular' | 'small'
}

export const CcqStatusIcon: React.FC<CcqStatusIconProps> = ({ card, size }) => {
  const className = classNames(styles[size], 'flex-shrink-0')
  if (card === CcqCards.MATCHED) {
    return <MatchedIcon className={className} aria-hidden='true' />
  }
  if (card === CcqCards.CLOSER) {
    return <CloserLookIcon className={className} aria-hidden='true' />
  }
  if (card === CcqCards.NOT_IN_RECORDS) {
    return <NotInRecordsIcon className={className} aria-hidden='true' />
  }
  if (card === CcqCards.MISSING_DATA) {
    // A block even inside the shared Button, which turns icons into flex boxes and shifts the glyph.
    return <i className={classNames('bi bi-question-circle d-block zocks-text-gray-600', className)} aria-hidden='true' />
  }
  return (
    <span className={classNames(className, 'd-flex align-items-center justify-content-center')} aria-hidden='true'>
      <span className={classNames(styles.dash, 'rounded-pill zocks-bg-color-gray-500')} />
    </span>
  )
}
